<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { update } from 'src/stores/ui/edit_lists';

	let text = '';

	switch ($update.type) {
		case 'ai_device_failure':
			text =
				$update.subType === 'enable_ai_model'
					? $format('label_enable_ai_model', {
							default: 'All selected devices will enable their AI model.',
						})
					: $format('label_disable_ai_model', {
							default: 'All selected devices will disable their AI model.',
						});

			break;
	}
</script>

<Text>{text}</Text>
